export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, context) => {
    console.error('Vue Error:', error)
    console.error('Context:', context)
  }

  nuxtApp.hook('app:error', (error) => {
    console.error('App Error:', error)
  })
})